import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { BackstagePodcastAllEpisodesSortDropdownKey } from '../../../../../../tools/Dropdowns/BackstagePodcastAllEpisodesSortDropdown';
import * as constants from '../../../constants';
import * as D from '../../../deps';

import './BackstagePodcastProgramSortDropdown.scss';

export class BackstagePodcastProgramSortDropdown extends React.Component {
  static propTypes = {
    openDropdown: PropTypes.func.isRequired,
    closeDropdown: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    initialSortingOrder: PropTypes.string,
  };

  static getDerivedStateFromProps(props, state) {
    // Initialize sort order based on server response, if FORWARD, then NEWEST_TO_OLDEST
    if (!state.hasInitializedSort && props.initialSortingOrder) {
      return {
        hasInitializedSort: true,
        sortType: props.initialSortingOrder,
      };
    }
    return null;
  }

  state = {
    isOpen: false,
    sortType: constants.AllEpisodesSortTypes.NEWEST_TO_OLDEST,
    hasInitializedSort: false,
  };

  closeDropdown = () => {
    this.setState({ isOpen: false });

    this.props.closeDropdown({
      menuType: BackstagePodcastAllEpisodesSortDropdownKey,
    });
  };

  onClick = e => {
    e.preventDefault();
    this.setState({ isOpen: true });

    this.props.openDropdown({
      menuType: BackstagePodcastAllEpisodesSortDropdownKey,
      config: this.getDropdownConfig(),
    });
  };

  getDropdownConfig = () => {
    const rect = this.refs.rootEl.getBoundingClientRect();

    return {
      activeSort: this.state.sortType,
      sortTypes: [
        constants.AllEpisodesSortTypes.NEWEST_TO_OLDEST,
        constants.AllEpisodesSortTypes.OLDEST_TO_NEWEST,
      ],
      position: {
        top: rect.bottom,
        left: rect.left - 4,
        height: 0,
      },
      onSortClicked: sortType => {
        this.setState({
          sortType,
          isOpen: false,
        });

        this.closeDropdown();
        this.props.onChange(sortType);
      },
      onCloseDropdown: () => {
        this.closeDropdown();
      },
    };
  };

  renderIcon = () => {
    const props = {
      glyph: D.chevronDownIcon,
      className: D.createBEM('PodcastProgramSortDropdown__icon', {
        active: this.state.isOpen,
      }),
    };

    return <D.Icon {...props} />;
  };

  render() {
    return (
      <button
        type='button'
        aria-haspopup='true'
        className='PodcastProgramSortDropdown'
        onClick={this.onClick}
        ref='rootEl'
      >
        <FormattedMessage {...constants.messages[this.state.sortType]} />
        {this.renderIcon()}
      </button>
    );
  }
}

const mapDispatchToProps = {
  openDropdown: D.Actions.Dropdown.openDropdown,
  closeDropdown: D.Actions.Dropdown.closeDropdown,
};

export default connect(null, mapDispatchToProps)(BackstagePodcastProgramSortDropdown);
